export default __webpack_public_path__ + "static/Cost-reduction-e5100be55cbb1ba51d74c4030dda0929.webp";